<template>
  <login-content />
</template>

<script>
import LoginContent from '@/components/LoginContent.vue';
export default {
  name: 'MrLoginPage',
  components: { LoginContent }
};
</script>